import { createSelector } from '@ngrx/store';
import { selectDepartmentByCode } from './department-selectors';
import { selectAllRegionGroups } from './entity-store-selectors';

export function selectOperationsRegionGroupByCompanyId(companyId: string) {
  return createSelector(
    selectRegionGroupsByCompanyId(companyId),
    selectDepartmentByCode('25'),
    (regionGroups, dep) => {
      if (dep == null) {
        return null;
      }
      return regionGroups.find((rg) => rg.departmentId === dep.id);
    },
  );
}

export function selectRegionGroupsByCompanyId(companyId: string) {
  return createSelector(selectAllRegionGroups, (regionGroups) =>
    regionGroups.valueSeq().filter((rg) => rg.companyId === companyId),
  );
}

export function selectRegionGroupyId(regionGroupId: string) {
  return createSelector(selectAllRegionGroups, (regionGroups) => regionGroups.get(regionGroupId));
}
